import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout }       from './pages/admin/AdminLayout';
import { MonstersPage }      from './pages/admin/monsters/MonstersPage';
import { MonsterFormPage }   from './pages/admin/monsters/MonsterFormPage';
import { MapsPage }          from './pages/admin/maps/MapsPage';
import { MapEditorPage }     from './pages/admin/maps/MapEditorPage';
import { SpellsPage }        from './pages/admin/spells/SpellsPage';
import { LaunchCombatPage }  from './pages/admin/combat/LaunchCombatPage';
import { UsersPage }         from './pages/admin/users/UsersPage';
// Página de configuração do sistema de ranking (pontos por evento + limite de exibição)
import { AdminRankingPage }  from './pages/admin/ranking/AdminRankingPage';
// Gestão de classes de personagem (Guerreiro, Mago, Ladino, Arqueiro, Clérigo)
import { ClassesPage }       from './pages/admin/classes/ClassesPage';
import { ClassFormPage }     from './pages/admin/classes/ClassFormPage';
import { SpriteManagerPage } from './pages/admin/sprites/SpriteManagerPage';
import { NpcConfigPage }     from './pages/admin/npcs/NpcConfigPage';
import { AdminItemPage }     from './pages/admin/items/AdminItemPage';
import { GameConfigPage }    from './pages/admin/gameconfig/GameConfigPage';
import { MissionsPage }      from './pages/admin/missions/MissionsPage';
import { AnnouncersPage }    from './pages/admin/announcers/AnnouncersPage';
import { EconomyPage }       from './pages/admin/economy/EconomyPage';
import HubMapAdminPage       from './pages/admin/HubMapAdminPage';

export default function AdminApp() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        {/* Redirect /admin → /admin/users */}
        <Route index element={<Navigate to="users" replace />} />

        {/* Utilizadores */}
        <Route path="users"              element={<UsersPage />} />

        {/* Monstros */}
        <Route path="monsters"           element={<MonstersPage />} />
        <Route path="monsters/new"       element={<MonsterFormPage />} />
        <Route path="monsters/:id/edit"  element={<MonsterFormPage />} />

        {/* Mapas */}
        <Route path="maps"               element={<MapsPage />} />
        <Route path="maps/hub"           element={<HubMapAdminPage />} />
        <Route path="maps/new"           element={<MapEditorPage />} />
        <Route path="maps/:id/edit"      element={<MapEditorPage />} />

        {/* Classes de Personagem */}
        <Route path="classes"            element={<ClassesPage />} />
        <Route path="classes/new"        element={<ClassFormPage />} />
        <Route path="classes/:id/edit"   element={<ClassFormPage />} />

        {/* Sprites */}
        <Route path="sprites"            element={<SpriteManagerPage />} />

        {/* NPCs do Hub — qual sprite cada papel (Ferreiro/Guardião/Mercadora) usa */}
        <Route path="npcs"               element={<NpcConfigPage />} />

        {/* Inventário (Itens) */}
        <Route path="items"              element={<AdminItemPage />} />

        {/* Feitiços */}
        <Route path="spells"             element={<SpellsPage />} />

        {/* Lançar Combate */}
        <Route path="launch"             element={<LaunchCombatPage />} />

        {/* Configurações Globais do Jogo */}
        <Route path="gameconfig"         element={<GameConfigPage />} />
        <Route path="missions"           element={<MissionsPage />} />
        <Route path="announcers"         element={<AnnouncersPage />} />

        {/* Ranking — configuração de pontuação e exibição do leaderboard */}
        <Route path="ranking"            element={<AdminRankingPage />} />

        {/* Economia — carteira virtual "Ta Feito" e auditoria */}
        <Route path="economy"            element={<EconomyPage />} />

        {/* Fallback */}
        <Route path="*"                  element={<Navigate to="users" replace />} />
      </Route>
    </Routes>
  );
}
